<script>
import IconMaterial from '@/assets/img/Sidebar/Icon material-dashboard.svg'
import IconStickyNote from '@/assets/img/Sidebar/Icon awesome-sticky-note.svg'

const sidebarMenu = [
  // { path: '/', icon: 'fa fa-th', title: 'Home' },

  // //Highlight
  // { path: '/dashboard/highlight', icon: 'far fa-th-large', title: 'Highlights',
  //   children : [
  //     { path: '/dashboard/highlight/label-maker', title: 'Label Maker' },
  //     { path: '/dashboard/highlight/oil-maker', title: 'Oil Maker' },
  //     { path: '/dashboard/highlight/customer', title: 'Customer' },
  //   ]
  // },

  //Stock Opname
  { path: '/dashboard/stock-opname', img: IconMaterial, title: 'Stock Opname' },

  //Highlights
  { path: '/dashboard/highlight', icon : 'fa fa-sticky-note', title: 'Highlights' },

  // Settings
  { 
    path : '/dashboard/settings' , icon : 'fa fa-cog' , title : 'Settings',
    children : [
      { path : '/dashboard/settings/user-management' , title : 'User Management'},
      { path : '/dashboard/settings/unit-management' , title : 'Unit Management'}
    ]
  }


  // //Reports
  // { path: '/dashboard/reports', icon: 'far fa-file-alt', title: 'Reports',
  //   children: [
  //     { path: '/dashboard/reports/customer', title: 'Report Customer' },
  //     { path: '/dashboard/reports/label-maker', title: 'Report Label Maker' },
  //     { path: '/dashboard/reports/oil-maker', title: 'Report Oil Maker' },
  //     { path: '/dashboard/reports/suspect', title: 'Report Suspect' },
  //     { path: '/dashboard/reports/qrcode', title: 'QR Code' },
  //   ]
  // },

  // //Settings
  // { path: '/dashboard/settings', icon: 'far fa-wrench', title: 'Settings',
  //   children: [
  //     { path: '/dashboard/settings/log-history-activity', title: 'Log History Activity' },
  //     { path: '/dashboard/settings/user-management', title: 'User Management',
  //       children : [
  //         { path: '/dashboard/settings/user-management/dashboard-user', title: 'Dashboard User' },
  //         { path: '/dashboard/settings/user-management/oil-maker-app', title: 'Oil Maker App' },
  //         { path: '/dashboard/settings/user-management/penindakan-app', title: 'Penindakan App' },
  //       ]
  //     },
  //   ]
  // },


]

export default sidebarMenu;
</script>
